import React from 'react'
import { PLACEHOLDER } from '../../../group_leader/helpers/value'
import PropTypes from 'prop-types'
import { DataTable } from '../../../group_leader/components/common'
import { makeT } from '../../../group_leader/helpers/i18n'
import { cellValue, entryAffiliation, entryName, primaryColumnKey } from '../../helpers/columns'
import { entryIsPlaying } from '../../helpers/results'
import PlayingTag from './PlayingTag'
import PositionBadge from './PositionBadge'

const t = makeT('group_leader.event_results.leaderboard')

// Every non-match-play format: the blob's columns, or position / golfer / primary figure on phones.
const StandardLeaderboard = ({ entries, columns, name }) => {
  const primaryKey = primaryColumnKey(columns)

  const renderCell = (entry, column) => {
    if (column.key === 'position') {
      return <PositionBadge entry={entry}/>
    }
    if (column.key === 'name') {
      const affiliation = entryAffiliation(entry)
      return (
        <>
          <span className="gl-event-results-player-name">{entryName(entry)}</span>
          {entryIsPlaying(entry) && <PlayingTag/>}
          {affiliation && <span className="gl-event-results-player-affiliation">{affiliation}</span>}
        </>
      )
    }
    return <span className="gl-event-results-score-val">{cellValue(entry, column.key)}</span>
  }

  return (
    <DataTable
      columns={columns}
      rows={entries}
      rowKey={(entry, index) => entry.id_str || entry.id || index}
      renderCell={renderCell}
      ariaLabel={t('aria_label', { name })}
      renderMobileRow={(entry) => (
        <div className="gl-event-results-lb-mobile-row">
          {columns.some((column) => column.key === 'position') && (
            <PositionBadge entry={entry}/>
          )}
          <div className="gl-event-results-lb-mobile-name">
            {entryName(entry)}
            {entryIsPlaying(entry) && <PlayingTag/>}
            {entryAffiliation(entry) && (
              <span className="gl-event-results-player-affiliation">{entryAffiliation(entry)}</span>
            )}
          </div>
          <div className="gl-event-results-lb-mobile-score">
            {primaryKey ? cellValue(entry, primaryKey) : PLACEHOLDER}
          </div>
        </div>
      )}
      />
  )
}

StandardLeaderboard.propTypes = {
  entries: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
}

export default StandardLeaderboard
